export enum ChatStatus {
  INITIAL,
  LOADING,
  COMPLETE,
  ERROR,
}

export interface PrechatFields {
  firstName: string;
  lastName: string;
  email: string;
  subject?: string;
  bookingReference?: string;
}

export interface AgentforceChatFields {
  FirstName_c: string;
  LastName_c: string;
  Email_c: string;
  Subject_c?: string;
  WebSite_Country?: string;
  WebSite_Language?: string;
  Booking_Reference?: string;
  hiddenFields?: AgentforceHiddenProfileFields;
  Site_Origin?: string;
  Browser?: string | RegExpMatchArray;
  Browser_Language?: string;
  User_Agent?: string;
  Visitor_IP_Address_c?: string;
}

export interface ChatVisitorIpResponse {
  msepoch: string;
  remote_addr: string;
}

export interface AgentforceHiddenProfileFields {
  Finnair_Plus_Number_c?: string;
  Case_Member_Tier_c?: string;
  Member_Tier?: string;
  AuthenticatedUser?: string;
}

/**
 * HelpButton Status
 */
export enum HelpButtonStatus {
  VISIBLE = 'visible', // Help Button is visible
  CLICKED = 'clicked', // Help Button is clicked
  CHAT = 'chat', // SF Chat is waiting until open
  HIDDEN = 'hidden', // Help Button is not visible when SF Chat is open
}

export interface AgentforceQueueConfig {
  deploymentId: string;
  buttonId: string;
  agentUrl: string;
}

export interface AgentforceChatConfig {
  disableLangRefresh?: boolean;
  chatScriptSrcURL: string;
  scrt2URL: string;
  queueConfigs: AgentforceQueueConfig;
}

export enum CustomAgentforceEventRoles {
  SYSTEM = 'System',
  BOT = 'Chatbot',
  END_USER = 'EndUser',
}

export interface EmbeddedBootstrapSvc {
  settings: Record<string, unknown>;
  init: (deploymentId: string, buttonId: string, agentUrl: string, options: { scrt2URL: string }) => void;
  prechatAPI: {
    setHiddenPrechatFields?: (formData: AgentforceChatFields) => void;
  };
  utilAPI: {
    launchChat: () => Promise<void>;
  };
  userVerificationAPI: {
    clearSession: (eventName: boolean) => Promise<void>;
  };
}

export type SupportedAgentforceLanguages =
  | 'en'
  | 'zh_CN'
  | 'zh_HK'
  | 'es'
  | 'de'
  | 'fi'
  | 'fr'
  | 'it'
  | 'ja'
  | 'ko'
  | 'sv'
  | 'et'
  | 'pl'
  | 'no'
  | 'da'
  | 'ru';

export const LOCALE_TO_AGENTFORCE_LANG: Record<string, SupportedAgentforceLanguages> = {
  _DEFAULT: 'en',
  'fi-fi': 'fi',
  'fi-sv': 'sv',
  'se-sv': 'sv',
  'ca-fr': 'fr',
  'fr-fr': 'fr',
  'ch-fr': 'fr',
  'at-de': 'de',
  'de-de': 'de',
  'ch-de': 'de',
  'it-it': 'it',
  'es-es': 'es',
  'cn-zh': 'zh_CN',
  'kr-ko': 'ko',
  'jp-ja': 'ja',
  'hk-zh': 'zh_HK',
  'ru-ru': 'ru',
  'ee-et': 'et',
  'pl-pl': 'pl',
  'no-no': 'no',
  'dk-da': 'da',
};
